import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStmicroelectronicsComponent } from './simple-icons-stmicroelectronics.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStmicroelectronicsComponent ],
    exports:      [ SimpleIconsStmicroelectronicsComponent ],
    bootstrap:    []
})
export class SimpleIconsStmicroelectronicsModule {}
